import axios from '@/utils/http';

export default url => {
  return axios
    .post(url)
    .then(data => Promise.resolve(data.data))
    .catch(err => Promise.reject(err));
};
